import { useEffect, useState } from "react";

import { useGetJobQuery } from "@js/apps/jobs/api";

import { useFilteredBidList } from "../use-filtered-bid-list";

type UseJobBidsConfig = { jobId: number; isInterviewingTab?: boolean };
export const useJobBids = ({ jobId, isInterviewingTab }: UseJobBidsConfig) => {
  const {
    bidList,
    isBidListLoading,
    isBidListFetching,
    refetchBidList,
    bidFilters,
    areFiltersDefault,
    total,
    isLastPage,
    resetFilters,
  } = useFilteredBidList({
    jobId,
    refetchOnMountOrArgChange: true,
    isInterviewingTab: !!isInterviewingTab,
  });

  const {
    data: job,
    refetch: refetchJob,
    isLoading: isJobLoading,
  } = useGetJobQuery({ id: Number(jobId) });

  // delay by 1 render circle to align with virtualized bids
  const [
    showEditJobRequirementCTADelayed,
    setShowEditJobRequirementCTADelayed,
  ] = useState(false);

  useEffect(() => {
    const showEditJobRequirementCTA =
      (!!bidList.length || (!bidList.length && !areFiltersDefault)) &&
      isLastPage;

    if (!showEditJobRequirementCTA) {
      return setShowEditJobRequirementCTADelayed(false);
    }

    const timeout = setTimeout(() => {
      setShowEditJobRequirementCTADelayed(true);
    }, 100);

    return () => clearTimeout(timeout);
  }, [areFiltersDefault, bidList.length, isLastPage]);

  return {
    loading: !job || isJobLoading || isBidListLoading,
    jobBidsLoading: isBidListLoading,
    jobBidsFetching: isBidListFetching,
    job,
    bidList,
    totalBidsCount: total || 0,
    refetchBidList,
    refetchJob,
    areFiltersDefault,
    isShowingHiddenBids: !!bidFilters?.is_hidden,
    resetFilters,
    showEditJobRequirementCTA: showEditJobRequirementCTADelayed,
  };
};
